import { createFileRoute, Outlet } from '@tanstack/react-router';

import { BackendContainer } from '@/components/backend/BackendContainer';
import { ErrorAlert } from '@/components/errors/ErrorAlert';
import { makeMetaTitle } from '@/modules/META';
import { backendApiAdminLevelsFindOneOptions } from '@/modules/api/@tanstack/react-query.gen';
import { useAdminLevelSuspenseQuery } from '@/queries/useAdminLevelSuspenseQuery';

export const Route = createFileRoute('/verwaltung/$adminLevelId')({
  loader: async ({ params: { adminLevelId }, context: { queryClient } }) => {
    await queryClient.ensureQueryData(backendApiAdminLevelsFindOneOptions({ path: { adminLevelId } }));
  },

  head: async ({
    params: { adminLevelId },
    match: {
      context: { queryClient },
    },
  }) => {
    const adminLevel = await queryClient.ensureQueryData(
      backendApiAdminLevelsFindOneOptions({ path: { adminLevelId } }),
    );

    return {
      meta: [makeMetaTitle([`Verwaltungsebene ${adminLevel.name}`])],
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
});

function RouteComponent() {
  const { error } = useAdminLevelSuspenseQuery();

  return <BackendContainer>{error ? <ErrorAlert error={error} /> : <Outlet />}</BackendContainer>;
}
